export const getBrand = () => {
  if (window._THULEDATA !== null) {
    return window._THULEDATA.SitecoreSiteName;
  } else if (window._EXTRANETDATA !== null) {
    return window._EXTRANETDATA.SitecoreSiteName;
  }

  return '';
};

export const GetDeviceParameterData = () => {
  if (window.innerWidth <= 767) return 'Mobile';

  if (window.innerWidth <= 991) return 'Tablet';

  return 'Desktop';
}